/* Автоматически генерируемый файл */
import { cnTheme, type Theme } from '@direct-frontend/components';

import { themeSizeTokens } from './themeSizeTokens';

import '../light/color.css';
import '../dark/color.css';
import './root.css';

export const kitMobileLightTheme: Theme = {
    main: cnTheme({ kit: true, color: 'light' }),
    inverted: cnTheme({ kit: true, color: 'dark' }),
    root: cnTheme({ kit: true, root: true, view: 'mobile' }),
    sizeTokens: themeSizeTokens,
};

export const kitMobileDarkTheme: Theme = {
    main: cnTheme({ kit: true, color: 'dark' }),
    inverted: cnTheme({ kit: true, color: 'light' }),
    root: cnTheme({ kit: true, root: true, view: 'mobile' }),
    sizeTokens: themeSizeTokens,
};
